import { BELOW } from "/constants/button_additional_text_position";
export default {
    withButtonArrow: true,
    additionalText: null,
    additionalTextPosition: BELOW,
    additionalTextMaxWidth: null
};
